import PartnerContainer from '../../containers/Partner';

interface Props {}

function PartnerDetail(props: Props) {
  return <PartnerContainer />;
}

export default PartnerDetail;
